import { render, staticRenderFns } from "./RadioSubscribe.vue?vue&type=template&id=0081134c&scoped=true&"
import script from "./RadioSubscribe.vue?vue&type=script&lang=js&"
export * from "./RadioSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./RadioSubscribe.vue?vue&type=style&index=0&id=0081134c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081134c",
  null
  
)

export default component.exports